// extracted by mini-css-extract-plugin
export default {"desktop":"cTHHSEsAkZFTDF3KxgUx","mobile":"WSc87s9Sk0d_1ZEc3Fps","pulse":"JhnVbzc7mV8yJPu33pRI"};